import { PieChart as RPie, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { colors } from '../../lib/colors';

interface Props {
  data: Record<string, any>[];
  nameKey: string;
  valueKey: string;
  height?: number;
}

const PALETTE = ['#EF9F27', '#BA7517', '#FAB055', '#FCC683', '#FDDCAE', '#FEEAD0', '#854F0B', '#B4B2A9'];

export function PieChart({ data, nameKey, valueKey, height = 260 }: Props) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RPie>
        <Pie
          data={data}
          dataKey={valueKey}
          nameKey={nameKey}
          innerRadius={50}
          outerRadius={90}
          paddingAngle={1}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{ background: colors.surface, border: `0.5px solid ${colors.border}`, borderRadius: 8, fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 11, color: colors.textSecondary }} />
      </RPie>
    </ResponsiveContainer>
  );
}
